// src/queries/customers/addresses.js
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@services/api";
import { normalizeCoordinateRecord } from "@lib/coordinates";

export function useCustomerAddressesQuery(customerId) {
  return useQuery({
    queryKey: ["customers", "addresses", customerId],
    queryFn: async () => {
      const { data } = await api.get(`/customers/${customerId}/addresses`);
      return {
        ...data,
        data: Array.isArray(data?.data)
          ? data.data.map((row) => normalizeCoordinateRecord(row))
          : [],
      };
    },
    enabled: !!customerId,
  });
}

export function useCreateAddressMutation(customerId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload) => {
      const { data } = await api.post(`/customers/${customerId}/addresses`, payload);
      return data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["customers", "addresses", customerId] });
    },
  });
}

export function useUpdateAddressMutation(customerId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ address_id, ...payload }) => {
      const { data } = await api.patch(`/addresses/${address_id}`, payload);
      return data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["customers", "addresses", customerId] });
    },
  });
}

export function useDeleteAddressMutation(customerId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (address_id) => {
      const { data } = await api.delete(`/addresses/${address_id}`);
      return data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["customers", "addresses", customerId] });
    },
  });
}

